import { render, staticRenderFns } from "./addproductbuy.vue?vue&type=template&id=1d52abce&scoped=true"
import script from "./addproductbuy.vue?vue&type=script&lang=js"
export * from "./addproductbuy.vue?vue&type=script&lang=js"
import style0 from "./addproductbuy.vue?vue&type=style&index=0&id=1d52abce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d52abce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d52abce')) {
      api.createRecord('1d52abce', component.options)
    } else {
      api.reload('1d52abce', component.options)
    }
    module.hot.accept("./addproductbuy.vue?vue&type=template&id=1d52abce&scoped=true", function () {
      api.rerender('1d52abce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/addproductbuy.vue"
export default component.exports